import { PageViewEventLogger } from '@repo/tracking-service';
import { SignBackButtonLayout, SignTerms } from '@repo/user-sign';
import { ReactElement } from 'react';

const SignUpTermsPage = () => {
  return (
    <>
      <SignTerms />
      <PageViewEventLogger pageName={'sign-up-terms'} eventOption={{ isUseAirbridge: true }} />
    </>
  );
};

SignUpTermsPage.getLayout = (page: ReactElement) => <SignBackButtonLayout>{page}</SignBackButtonLayout>;


export default SignUpTermsPage;
